import { useTranslation } from 'react-i18next'

import { LiveAgo } from '@/components/inspections/LiveAgo'

const pillBase =
  'inline-flex shrink-0 items-center rounded-[100px] border px-2 py-0.5 font-[family-name:var(--stryzh-font-family-inter)] text-[length:var(--stryzh-font-size-xs)] font-medium uppercase tracking-[0.5px]'

/** Header pill: «👤 у вас / у Алексея / свободен» — рядом со статусом лида. */
export function AssignedBadge({
  assignedTo,
  assignedToName,
  assignedAt,
  isMine,
}: {
  assignedTo: string | null
  assignedToName: string | null
  assignedAt: string | null
  isMine: boolean
}) {
  const { t } = useTranslation()
  if (!assignedTo) {
    return (
      <span
        className={`${pillBase} border-[color:var(--stryzh-color-border-default)] bg-[color:var(--stryzh-color-bg-elev)] text-[color:var(--stryzh-color-text-secondary)]`}
      >
        {t('leads.detail.free')}
      </span>
    )
  }
  const label = isMine ? t('leads.detail.withYou') : `👤 ${assignedToName ?? assignedTo.slice(0, 8)}`
  const colorCls = isMine
    ? 'border-blue-500/40 bg-blue-500/10 text-blue-300'
    : 'border-[color:var(--stryzh-color-border-default)] bg-[color:var(--stryzh-color-bg-elev)] text-[color:var(--stryzh-color-text-secondary)]'
  return (
    <span className={`${pillBase} ${colorCls}`} title={assignedToName ?? assignedTo}>
      {label}
      {assignedAt ? (
        <span className="ml-1 normal-case font-normal opacity-80">
          {' · '}<LiveAgo from={assignedAt} />
        </span>
      ) : null}
    </span>
  )
}

/** Бейдж «клиент уже есть в Carlink» — лид по телефону нашёлся среди контактов
 *  respond.io (проверяет edge respond-lookup-contact при создании лида).
 *  Показывается только когда совпадение есть. */
export function CarlinkBadge() {
  const { t } = useTranslation()
  return (
    <span className={`${pillBase} border-cyan-400/30 bg-cyan-400/10 text-cyan-300`} title={t('leads.detail.carlinkBadgeTitle')}>
      {t('leads.detail.carlinkBadge')}
    </span>
  )
}
